// ─────────────────────────────────────────────────────────────
//  CONFIGURATION  —  update these two values before deploying
// ─────────────────────────────────────────────────────────────
export const msalConfig = {
  auth: {
    clientId: "83485523-f2a2-4d26-bb2d-53804636d385",
    authority: "https://login.microsoftonline.com/e97c7a94-f179-4b45-9ccf-4cfa20193cfd",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",  // persist across tabs/refreshes
    storeAuthStateInCookie: true,   // helps with iframe/cross-site issues
  },
  system: {
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 10000,
    loadFrameTimeout: 10000,
    tokenRenewalOffsetSeconds: 300,
  },
};

export const loginRequest = {
  scopes: [
    "User.Read",
    "Sites.Read.All",
    "Sites.ReadWrite.All",
    "Files.ReadWrite.All",
    "User.ReadBasic.All",
    "Sites.Manage.All",
  ],
};

// ─────────────────────────────────────────────────────────────
//  SharePoint site details
// ─────────────────────────────────────────────────────────────
export const SP_CONFIG = {
  hostname: "rpsigns.sharepoint.com",
  sitePath: "/",
  poRootFolder: "Purchase Orders",
  commentsListName: "PO Comments",
  closedFolder: "ZClosed",
};
